import axios from 'axios'
import * as types from '../mutation-types'
import moment from 'moment-timezone';

const localTimeZone = moment.tz.guess()
/**
 * State
 */
export const state = {
  status: null,
  startDate: null,
  endDate: null,
  startTime: null,
  endTime: null
}
/**
 * Getters
 */
export const getters = {
  maintenanceStatus: state => {
    return state.status
  },

  startDateTime: state => {
    let startDateTime = state.startDate + 'T' + state.startTime
    startDateTime = moment.tz(startDateTime, "YYYY-MM-DD HH:mm", "America/New_York")
    return startDateTime.tz(localTimeZone).format('lll')
  },

  endDateTime: state => {

    let endDateTime = state.endDate + 'T' + state.endTime
    endDateTime = moment.tz(endDateTime, "YYYY-MM-DD HH:mm", "America/New_York")
    return endDateTime.tz(localTimeZone).format('lll')
  }
}

/**
 * Mutations
 */
export const mutations = {
  [types.SET_MAINTENANCE] (state, { formRelease }) {
    state.status = true
    state.startDate = formRelease.startDate
    state.endDate = formRelease.endDate
    state.startTime = formRelease.startTime
    state.endTime = formRelease.endTime
  },

  [types.DISABLE_MAINTENANCE] (state) {
    state.status = false
    state.startDate = null
    state.endDate = null
    state.startTime = null
    state.endTime = null
  }
}

/**
 * Actions
 */
export const actions = {
  async checkMaintenanceSchedule({ commit }) {
    try {
      const { data } = await axios.get('api/maintenance/check')
      if (data.code == "MAI-001") {
        commit(types.DISABLE_MAINTENANCE)
      } else { 
        let formRelease = {
          startDate: data.data.Start_Date__c,
          endDate: data.data.End_Date__c,
          startTime: data.data.Start_Time__c,
          endTime: data.data.End_Time__c
        }
        commit(types.SET_MAINTENANCE, { formRelease: formRelease })
      }
    } catch (e) {
      commit(types.DISABLE_MAINTENANCE)
    }
  }

}


// WEBPACK FOOTER //
// ./resources/js/store/modules/maintenance.js